import React, { useState } from 'react';

import './LoginForm.scss';
import images from '../../shared/assets/images';
import { validate, resetStyles } from '../../helpers/form';

const { logo } = images;

export default function LoginForm(props) {
  const [status, updateStatus] = useState(null);

  return (
    <section id="login">
      <div id="login_logo">
        <img alt="logo" src={logo} />
      </div>

      <h2 id="login_title">Inloggen</h2>

      <form
        name="login"
        id="login_form"
        autoComplete="off"
        onSubmit={(e) => login(e)}
        onKeyDown={(e) => reset(e)}
      >
        {status && <div id="login_error">{status}</div>}

        <label htmlFor="login_username">Gebruikersnaam of email</label>
        <input
          autoFocus
          type="text"
          name="username"
          id="login_username"
          placeholder="email@email.com"
        />

        <label htmlFor="login_password">Wachtwoord</label>
        <input
          type="password"
          name="password"
          id="login_password"
          placeholder="Wachtwoord..."
        />

        <div id="login_links">
          <a href={props.signupUrl}>Registreren</a>

          <a href={props.passwordResetUrl}>Wachtoord vergeten?</a>

          <a href={props.retrieveUsernameUrl}>Gebruikersnaam vergeten?</a>
        </div>

        <div id="login_button">
          <button tabIndex="0" type="submit">
            Inloggen
          </button>
        </div>
      </form>
    </section>
  );

  function login(e) {
    e.preventDefault();

    const { username, password } = document.login;
    const isValidated = validate(username, password);

    if (!isValidated) return;

    const xhr = new XMLHttpRequest();

    xhr.open('POST', props.authUrl);

    xhr.send(
      JSON.stringify({
        username: username.value,
        password: password.value
      })
    );

    xhr.onload = () => {
      if (xhr.status === 200) {
        const jwt = JSON.parse(xhr.response).jwt;

        setCookie('jwt', jwt, 3);

        location.href = props.redirectUrl || 'dashboard';
      } else {
        updateStatus(`De gebruikersnaam of het wachtwoord
          dat u hebt ingevoerd is ongeldig`);
      }
    };

    xhr.onerror = () => updateStatus('Verbindingsfout');
  }

  function reset(e) {
    if (status) updateStatus(null);

    resetStyles(e.target);
  }
}

function setCookie(name, value, exdays) {
  const date = new Date();

  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);

  const expires = `expires=${date.toUTCString()}`;

  document.cookie = `${name}=${value};${expires};path=/`;
}
